<template>
  <b-container>
    <div>
      <b-navbar
        toggleable="lg"
        variant="faded"
        type="light"
        class="marketplace-navbar"
      >
        <!-- LEFT -->
        <b-navbar-nav>
          <b-nav-item href="#" class="padding-adjustment">
            <b-button style="padding: 0; border: 0; background-color: white; border-color: white;" size="sm" v-b-toggle.sidebar-menu>
              <b-icon-grid3x3-gap-fill style="color: #838383;"></b-icon-grid3x3-gap-fill>
            </b-button>
          </b-nav-item>

          <b-navbar-brand href="#">
            <img
            src="../../../src/assets/images/dropsmart-logo.png"
            alt="Dropsmart Logo"
            />
          </b-navbar-brand>

          <!-- MENU ITEMS
          @click="$emit('navigate', 'Academy'); itemSelected(2); goToUrl('Academy');" 
          -->
          <div v-for="(item, index) in menuItems" :key="index" class="menu-item-container" 
          @click="isActive = index"
          :class="{active:isActive === index}">
          <b-nav-item>
            {{item}}
          </b-nav-item>
          </div>
        </b-navbar-nav>
        
         <!-- RIGHT/ICONS -->
        <b-navbar-nav>
          <b-nav-item href="#" class="padding-adjustment"
            ><b-icon-person-circle style="color: #838383;"></b-icon-person-circle
          ></b-nav-item>
          <b-nav-item href="#"
            ><b-icon-basket3 style="color: #838383;"></b-icon-basket3
          ></b-nav-item>
        </b-navbar-nav>

        <!-- DISABLED -->
        <!-- <b-navbar-toggle target="nav-collapse" v-if="false"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav v-if="false">
          <b-navbar-nav class="search-area-container">
            <b-input-group size="sm" class="mb-2 search-area">
              <b-input-group-prepend is-text class="search-icon-box">
                <b-icon-search variant="dark"></b-icon-search>
              </b-input-group-prepend>
              <b-form-input
                type="search"
                placeholder="Search for something"
                class="search-input form-control"
              ></b-form-input>
            </b-input-group>
          </b-navbar-nav>

          <b-navbar-nav class="buttons-icons">
            <b-nav-item href="#" class="padding-adjustment"
              ><b-icon-person-circle variant="dark"></b-icon-person-circle
            ></b-nav-item>
            <b-nav-item href="#"
              ><b-icon-suit-heart variant="dark"></b-icon-suit-heart
            ></b-nav-item>
            <b-nav-item href="#"
              ><b-icon-basket3 variant="dark"></b-icon-basket3
            ></b-nav-item>
          </b-navbar-nav>
        </b-collapse> -->
      </b-navbar>
    </div>
  </b-container>
</template>

<script>
export default {
  name: "HeaderNavBar",
  props: ["menuItems"],
  data() {
    return {
      isActive: 0,
    };
  },
};
</script>

<style scoped lang="scss">
.container {
  padding: 0;
}

.form-control:focus {
  border-color: none;
  box-shadow: none;
}
.marketplace-navbar {
  justify-content: space-between; //in case to also show the search bar and the other icons
  //justify-content: center; //if just the brand is up there
  align-items: end;
  padding-right: 0;
  padding-left: 0;

  ul.navbar-nav {
  align-items: end;

    a.nav-link {
    padding: 0 0;
    //margin: 0 1rem;
    }

    a.navbar-brand {
    //padding: 0;
    margin: 0 0 0 1rem;
    max-width: 180px;

      img {
        vertical-align: bottom;
        max-width: 90%;
        //max-height: 31px; maintain it if all the navbar is shown
      }
    }

    .menu-item-container {
      border: none;
      margin: 0 1rem;

      a.nav-link {
        padding: 0;
      }

      &:hover {
        border-bottom: 2px solid #838383;
      }

    }

    .menu-item-container.active {
      border-bottom: 2px solid #838383;

    }

  }
}



li {
  list-style: none;
  padding: 0;
  margin: 0;
  a {
    color: black;
  }
}

li.padding-adjustment:first-child {
  margin: 0 1rem 0 0;
}

li.padding-adjustment {
  margin: 0 1rem;
}

.search-area-container {
  width: 100%;
}

.search-input {
  background-color: transparent;
  border: none;
}

.search-area {
  margin: 0 1.2rem;
  border-radius: 3rem;
  background-color: #ffffff;
  border: solid 1px black;

  .search-icon-box {
    background-color: transparent;
    border: none;

    .input-group-text {
      background-color: transparent;
      border: none;
    }
  }
}

a.nav-link {
  padding: 0;
  //height: 31px;

  svg {
    height: 31px;
    width: 25px;
  }
}

li:last-child {
  a.nav-link {
    //padding-right: 0;
  }
}

@media screen and (max-width: 991px) {
  .navbar-collapse[data-v-d588945e] {
    display: flex;
    margin-top: 1rem;
  }
  .search-area-container[data-v-d588945e] {
    flex-direction: row;
  }
  div.search-area {
    margin-left: 0;
  }
}

@media screen and (min-width: 992px) {
  .navbar-collapse {
    align-items: stretch;
  }
}
</style>
